import React from "react";
import { useNavigate } from "react-router-dom";
import { ADMIN_LOGIN_SESSION_STORAGE_KEY } from "../../AppConstants";
import { useAdminLoggedIn } from "../../hooks";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBook } from "@fortawesome/free-solid-svg-icons";
// import { faPerson } from "@fortawesome/free-solid-svg-icons";
// import { faPencil } from "@fortawesome/free-solid-svg-icons";
// import { faEarthAsia } from "@fortawesome/free-solid-svg-icons";
// import { faFilm } from "@fortawesome/free-solid-svg-icons";
// import { faMasksTheater } from "@fortawesome/free-solid-svg-icons";
// import { faHeart } from "@fortawesome/free-solid-svg-icons";

export const AdminDashboard = () => {
  // const closedBook = <FontAwesomeIcon icon={faBook} size="sm" />;
  // const person = <FontAwesomeIcon icon={faPerson} size="sm" />;
  // const pencil = <FontAwesomeIcon icon={faPencil} size="sm" />;
  // const earth = <FontAwesomeIcon icon={faEarthAsia} size="sm" />;
  // const film = <FontAwesomeIcon icon={faFilm} size="sm" />;
  // const theaterMasks = <FontAwesomeIcon icon={faMasksTheater} size="sm" />;
  // const heart = <FontAwesomeIcon icon={faHeart} size="sm" />;

  const navigate = useNavigate();
  useAdminLoggedIn();

  const onLogoutClick = () => {
    sessionStorage.removeItem(ADMIN_LOGIN_SESSION_STORAGE_KEY);
    navigate("/");
  };

  return (
    <div>
      <h1>Admin Dashboard</h1>
      <div className="content_element">
        <div className="admin-content">
          <div className="admin-link">
            <a href="/media">Manage Media Info - Add, Edit, or Delete</a>
          </div>
          <div className="admin-link">
            <a href="/creator">Manage Creators - Add, Edit, or Delete</a>
          </div>
          <div className="admin-link">
            <a href="/role">Manage Creator Roles - Add, Edit, or Delete</a>
          </div>
          <div className="admin-link">
            <a href="/background">
              Manage APIDA Identities - Add, Edit, or Delete
            </a>
          </div>
          <div className="admin-link">
            <a href="/mediaType">
              Manage Types of Media - Add, Edit, or Delete
            </a>
          </div>
          <div className="admin-link">
            <a href="/genre">Manage Genres - Add, Edit, or Delete</a>
          </div>
          <div className="admin-link">
            <a href="/theme">Manage Themes - Add, Edit, or Delete</a>
          </div>
          <br />
          <div className="logout-button">
            <button
              type="button"
              className="is-link btn btn-danger logout-button"
              onClick={onLogoutClick}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
